// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"863":"9aab875b7c75e70b78836bcd9eec8fa3","871":"5aed79a65bdc8029c32f9c1bc62c225c"}[chunkId] + ".js";
};